module.exports = __webpack_public_path__ + "img/2.659c59d7.jpg";